import * as C from 'actions/constants';

export const blankState = {
  list: [],
  meta: {},
  loading: false,
};

const DefaultSavedFilterReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_DEFAULT_SAVED_FILTERS: {
      return { ...state, loading: true };
    }
    case C.LOAD_DEFAULT_SAVED_FILTERS_SUCCESS: {
      const { data, meta } = action;
      return {
        ...state,
        loading: false,
        list: data,
        meta,
      };
    }
    case C.LOAD_DEFAULT_SAVED_FILTERS_ERROR: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};

export default DefaultSavedFilterReducer;
